<template>
  <div>
    <router-view v-show="$route.matched.length == 3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length < 3">
    <div class="main-page-content">
      <template v-if="viewMode === 'bill'">
        <el-row class="toolbar-row">
          <el-form :inline="true" :model="searchCondition">
            <el-row>
              <el-form-item label="账单ID">
                <el-input
                  v-model="searchCondition.id"
                  clearable
                  placeholder="请输入账单ID"
                  class="search-input"
                />
              </el-form-item>
              <el-form-item label="第三方账单ID">
                <el-input
                  v-model="searchCondition.bill_id"
                  clearable
                  placeholder="请输入第三方账单ID"
                  class="search-input"
                />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="searchButton">查询</el-button>
                <el-button @click="resetSearch">重置</el-button>
              </el-form-item>
            </el-row>
            
          </el-form>
          <ScreeCompany @ScreeCompany="handleCompanyFilter" />
        </el-row>

        <ApeTable
          ref="billTable"
          :data="billList"
          :columns="billColumns"
          :loading="loadingStaus"
          :pagingData="billPagingData"
          highlight-current-row
          @switchPaging="switchBillPaging"
        >
          <el-table-column fixed="right" align="center" label="操作" width="280">
            <template slot-scope="scope">
              <el-button
                v-if="canApply(scope.row)"
                size="mini"
                type="primary"
                @click="openPendingRecords(scope.row)"
              >
                申请开票
              </el-button>
              <el-button
                v-if="canViewOpened(scope.row)"
                size="mini"
                @click="openOpenedRecords(scope.row)"
              >
                发票详情
              </el-button>
              <el-button
                v-if="canViewOpened(scope.row)"
                size="mini"
                type="text"
                @click="downloadAllInvoices(scope.row)"
              >
                下载发票
              </el-button>
            </template>
          </el-table-column>
        </ApeTable>
      </template>

    </div>
  </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ScreeCompany from '@/components/ScreeCompany.vue'

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ScreeCompany,
  },
  data() {
    return {
      viewMode: 'bill',
      loadingStaus: false,
      applyLoading: false,
      applySubmitting: false,
      searchCondition: {},
      currentBill: {},
      billList: [],
      pendingList: [],
      openedList: [],
      selectedPendingRows: [],
      selectedOpenedRows: [],
      billSummary: {},
      pendingSummary: {},
      openedSummary: {},
      billPagingData: this.createPagingData(),
      pendingPagingData: this.createPagingData(),
      openedPagingData: this.createPagingData(),
      billColumns: [
        { title: '编号', value: 'id', width: 100, header_align: 'center', align: 'center' },
        { title: '公司名称', value: 'company_name', header_align: 'center', align: 'center' },
        { title: '税源地', value: 'channel_name', header_align: 'center', align: 'center' },
        { title: '待开票金额', value: 'pending_invoice_amount', width: 140, header_align: 'center', align: 'center' },
        { title: '已开票金额', value: 'opened_invoice_amount', width: 140, header_align: 'center', align: 'center' },
      ],
      pendingColumns: [
        { title: '记录ID', value: 'id', width: 100, header_align: 'center', align: 'center' },
        { title: '第三方账单ID', value: 'bill_id', width: 150, header_align: 'center', align: 'center' },
        { title: '开票金额', value: 'invoice_amount', width: 140, header_align: 'center', align: 'center' },
        { title: '开票服务商ID', value: 'biz_servicer_id', width: 140, header_align: 'center', align: 'center' },
        { title: '状态', value: 'status_desc', width: 120, header_align: 'center', align: 'center' },
      ],
      openedColumns: [
        { title: '记录ID', value: 'id', width: 100, header_align: 'center', align: 'center' },
        { title: '申请编号', value: 'apply_sn', width: 160, header_align: 'center', align: 'center' },
        { title: '发票ID', value: 'invoice_id', width: 140, header_align: 'center', align: 'center' },
        { title: '开票金额', value: 'invoice_amount', width: 120, header_align: 'center', align: 'center' },
        { title: '开票类目', value: 'invoice_content', header_align: 'center', align: 'center' },
        { title: '发票类型', value: 'invoice_type_desc', width: 130, header_align: 'center', align: 'center' },
        { title: '状态', value: 'status_desc', width: 120, header_align: 'center', align: 'center' },
      ],
      applyForm: this.createApplyForm(),
      applyRules: {
        invoice_content: [{ required: true, message: '请选择开票内容', trigger: 'change' }],
        invoice_type: [{ required: true, message: '请选择发票类型', trigger: 'change' }],
        is_paper_invoice: [{ required: true, message: '请选择是否纸质发票', trigger: 'change' }],
        receiver: [{ validator: this.validatePaperInvoiceField, trigger: 'blur' }],
        receiver_phone: [{ validator: this.validatePaperInvoiceField, trigger: 'blur' }],
        receiver_address: [{ validator: this.validatePaperInvoiceField, trigger: 'blur' }],
      },
      applyInitInfo: {},
      contentOptions: [],
      invoiceTypeOptions: [
        { value: '1', label: '增值税专票' },
        { value: '2', label: '增值税普票' },
      ],
      detailDialogVisible: false,
      detailInfo: null,
    }
  },
  computed: {
    selectedPendingAmount() {
      return this.formatMoney(this.sumAmount(this.selectedPendingRows, 'invoice_amount'))
    },
  },
  watch: {
    '$route'(to) {
      if (to.path === '/new_tax_invoice' && to.query.refresh) {
        this.loadBillRecords('search')
      }
    },
  },
  methods: {
    createPagingData() {
      return {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
      }
    },
    createApplyForm() {
      return {
        ids: [],
        invoice_title: '',
        org_code: '',
        channel_name: '',
        selected_amount: '',
        selected_count: 0,
        invoice_content: '',
        invoice_type: '2',
        is_paper_invoice: 'n',
        receiver: '',
        receiver_phone: '',
        receiver_address: '',
        receiver_email: '',
      }
    },
    validatePaperInvoiceField(rule, value, callback) {
      if (this.applyForm.is_paper_invoice !== 'y') {
        callback()
        return
      }
      if (rule.field === 'receiver' && !value) {
        callback(new Error('请输入收件人'))
        return
      }
      if (rule.field === 'receiver_phone' && !value) {
        callback(new Error('请输入收件人手机号'))
        return
      }
      if (rule.field === 'receiver_address' && !value) {
        callback(new Error('请输入收件地址'))
        return
      }
      callback()
    },
    handleCompanyFilter(v, name) {
      if (name === 'company') {
        if (v) {
          this.$set(this.searchCondition, 'company_id', v)
        } else {
          this.$delete(this.searchCondition, 'company_id')
        }
      }
      if (name === 'settlement') {
        if (v) {
          this.$set(this.searchCondition, 'channel_account', v)
        } else {
          this.$delete(this.searchCondition, 'channel_account')
        }
      }
      this.loadBillRecords('search')
    },
    searchButton() {
      this.loadBillRecords('search')
    },
    resetSearch() {
      this.searchCondition = {}
      this.loadBillRecords('search')
    },
    buildCommonParams(row = {}) {
      const companyId = row.company_id || this.searchCondition.company_id || this.mxCompanyId
      const channelAccount = row.channel_account || this.searchCondition.channel_account || this.mxSettlementId
      const params = {}
      if (companyId) params.company_id = companyId
      if (channelAccount) params.channel_account = channelAccount
      if (row.company_account_id || this.searchCondition.company_account_id) {
        params.company_account_id = row.company_account_id || this.searchCondition.company_account_id
      }
      return params
    },
    buildBillParams() {
      const params = {
        ...this.searchCondition,
        ...this.buildCommonParams(),
      }
      Object.keys(params).forEach((key) => {
        if (params[key] === '' || params[key] === null || typeof params[key] === 'undefined') {
          delete params[key]
        }
      })
      return params
    },
    getPagingInfo(refName, type) {
      const table = this.$refs[refName]
      if (table && table.getPagingInfo) {
        const pagingInfo = table.getPagingInfo(type)
        if (type === 'search') {
          pagingInfo.current_page = 1
        }
        return pagingInfo
      }
      return { current_page: 1, page_size: 10 }
    },
    normalizeListResp(result) {
      if (!result) {
        return { list: [], pages: { total: 0 } }
      }
      if (Array.isArray(result)) {
        return { list: result, pages: { total: result.length } }
      }
      return {
        list: result.data || result.list || [],
        pages: result.pages || { total: (result.data || result.list || []).length },
      }
    },
    async loadBillRecords(type) {
      this.loadingStaus = true
      const params = {
        ...this.buildBillParams(),
        ...this.getPagingInfo('billTable', type),
      }
      try {
        const result = await this.$api.getNewTaxInvoiceBillRecords(params)
        const { list, pages } = this.normalizeListResp(result)
        this.billSummary = {
          total_invoice_amount: result && result.total_invoice_amount,
          total_opened_invoice_amount: result && result.total_opened_invoice_amount,
        }
        this.billList = list.map(this.normalizeBillRow)
        this.billPagingData.total = (pages && pages.total) || 0
        this.billPagingData.page_size = pages && pages.page_size
        this.billPagingData.offset = pages && pages.offset
      } finally {
        this.loadingStaus = false
      }
    },
    normalizeBillRow(row) {
      return {
        ...row,
        company_name: row.company_name,
        channel_name: row.channel_name,
        pending_invoice_amount: row.pending_invoice_amount || row.invoice_amount || '0.00',
        opened_invoice_amount: row.opened_invoice_amount || '0.00',
      }
    },
    switchBillPaging() {
      this.loadBillRecords()
    },
    canApply(row) {
      return Number(row.pending_invoice_amount || row.invoice_amount || 0) > 0
    },
    canViewOpened(row) {
      return Number(row.opened_invoice_amount || 0) > 0
    },
    openPendingRecords(row) {
      this.$router.push({
        path: '/new_tax_invoice/apply',
        query: {
          company_id: row.company_id,
          channel_account: row.channel_account,
          company_account_id: row.company_account_id,
          company_name: row.company_name,
          channel_name: row.channel_name,
          pending_invoice_amount: row.pending_invoice_amount || row.invoice_amount,
        },
      })
    },
    async loadPendingRecords(type) {
      this.loadingStaus = true
      const params = {
        ...this.buildCommonParams(this.currentBill),
        ...this.getPagingInfo('pendingTable', type),
      }
      try {
        const result = await this.$api.getNewTaxInvoicePendingRecords(params)
        const { list, pages } = this.normalizeListResp(result)
        this.pendingSummary = {
          total_invoice_amount: result && result.total_invoice_amount,
        }
        this.pendingList = list.map((row) => ({
          ...row,
          status_desc: row.status_desc || row.status || '待开票',
        }))
        this.pendingPagingData.total = (pages && pages.total) || 0
        this.pendingPagingData.page_size = pages && pages.page_size
        this.pendingPagingData.offset = pages && pages.offset
        this.$nextTick(this.selectAllPendingRows)
      } finally {
        this.loadingStaus = false
      }
    },
    switchPendingPaging() {
      this.loadPendingRecords()
    },
    selectAllPendingRows() {
      const table = this.$refs.pendingTable && this.$refs.pendingTable.$refs.elTable
      if (!table) return
      this.pendingList.forEach((row) => {
        table.toggleRowSelection(row, true)
      })
    },
    handlePendingSelection(list) {
      this.selectedPendingRows = list || []
    },
    openApplyConfirmPage() {
      if (!this.selectedPendingRows.length) {
        this.$message.warning('请至少选择一条待开票记录')
        return
      }
      this.viewMode = 'applyConfirm'
    },
    async openApplyPage() {
      this.viewMode = 'apply'
      this.applyLoading = true
      const ids = this.selectedPendingRows.map((row) => row.id)
      try {
        const result = await this.$api.getNewTaxInvoiceApplyInit({
          ...this.buildCommonParams(this.currentBill),
          ids,
        })
        this.applyInitInfo = result || {}
        this.contentOptions = this.extractInvoiceContents(result)
        this.invoiceTypeOptions = (result && result.invoice_type_options && result.invoice_type_options.length)
          ? result.invoice_type_options
          : this.invoiceTypeOptions
        const purchaserInfo = (result && result.purchaser_info) || {}
        this.applyForm = {
          ...this.createApplyForm(),
          ids: (result && result.selected_ids) || ids,
          invoice_title: purchaserInfo.invoice_title || '',
          org_code: purchaserInfo.org_code || '',
          channel_name: (result && result.channel_name) || '',
          selected_amount: (result && result.selected_amount) || this.selectedPendingAmount,
          selected_count: (result && result.selected_count) || ids.length,
          invoice_type: String((this.invoiceTypeOptions[0] && this.invoiceTypeOptions[0].value) || '2'),
        }
        if (this.$refs.applyForm) {
          this.$refs.applyForm.clearValidate()
        }
      } finally {
        this.applyLoading = false
      }
    },
    extractInvoiceContents(result) {
      if (!result) return []
      if (Array.isArray(result.invoice_contents)) return result.invoice_contents
      if (result.invoice_content_result && result.invoice_content_result.data) {
        return result.invoice_content_result.data.invoice_contents || []
      }
      return []
    },
    getContentLabel(item) {
      if (typeof item === 'string') return item
      return item.label || item.name || item.invoice_content || item.content || item.value || ''
    },
    getContentValue(item) {
      if (typeof item === 'string') return item
      return item.value || item.invoice_content || item.content || item.name || item.label || ''
    },
    resetApplyPage() {
      this.applyLoading = false
      this.applySubmitting = false
      this.applyInitInfo = {}
      this.contentOptions = []
      this.applyForm = this.createApplyForm()
      if (this.$refs.applyForm) {
        this.$refs.applyForm.clearValidate()
      }
    },
    backToApplyConfirmPage() {
      this.viewMode = 'applyConfirm'
      this.resetApplyPage()
    },
    backToPendingRecords() {
      this.viewMode = 'pending'
      this.resetApplyPage()
      this.$nextTick(this.selectAllPendingRows)
    },
    submitApply() {
      this.$refs.applyForm.validate(async (valid) => {
        if (!valid) return
        this.applySubmitting = true
        try {
          const payload = {
            ...this.buildCommonParams(this.currentBill),
            ids: this.applyForm.ids,
            invoice_content: this.applyForm.invoice_content,
            invoice_type: this.applyForm.invoice_type,
            receiver: this.applyForm.receiver,
            receiver_phone: this.applyForm.receiver_phone,
            receiver_address: this.applyForm.receiver_address,
            receiver_email: this.applyForm.receiver_email,
            is_paper_invoice: this.applyForm.is_paper_invoice,
          }
          await this.$api.batchApplyNewTaxInvoice(payload)
          this.$message.success('开票申请已提交')
          this.resetApplyPage()
          this.backToBillList()
          this.loadBillRecords('search')
        } finally {
          this.applySubmitting = false
        }
      })
    },
    openOpenedRecords(row) {
      this.$router.push({
        path: '/new_tax_invoice/detail',
        query: {
          company_id: row.company_id,
          channel_account: row.channel_account,
          company_account_id: row.company_account_id,
          company_name: row.company_name,
          channel_name: row.channel_name,
          opened_invoice_amount: row.opened_invoice_amount,
        },
      })
    },
    async loadOpenedRecords(type) {
      this.loadingStaus = true
      const params = {
        ...this.buildCommonParams(this.currentBill),
        ...this.getPagingInfo('openedTable', type),
      }
      try {
        const result = await this.$api.getNewTaxInvoiceOpenedRecords(params)
        const { list, pages } = this.normalizeListResp(result)
        this.openedSummary = {
          opened_invoice_amount: result && result.opened_invoice_amount,
        }
        this.openedList = list.map((row) => ({
          ...row,
          invoice_type_desc: this.formatInvoiceType(row.invoice_type),
          status_desc: row.status_desc || row.status_alias || row.status || '-',
        }))
        this.openedPagingData.total = (pages && pages.total) || 0
        this.openedPagingData.page_size = pages && pages.page_size
        this.openedPagingData.offset = pages && pages.offset
      } finally {
        this.loadingStaus = false
      }
    },
    switchOpenedPaging() {
      this.loadOpenedRecords()
    },
    handleOpenedSelection(list) {
      this.selectedOpenedRows = list || []
    },
    canViewInvoice(row) {
      if (row.can_view_invoice === false) return false
      return row.status_code !== 'rejected'
    },
    canDownloadInvoice(row) {
      if (row.can_download_invoice === false) return false
      if (row.status_code === 'rejected') return false
      return this.parseUrlList(row.download_urls).length ||
        this.parseUrlList(row.pdf_oss_urls).length ||
        this.parseUrlList(row.invoice_file).length
    },
    async showDetail(row) {
      const id = row.id || row.invoice_id
      if (!id) {
        this.$message.warning('记录ID不存在')
        return
      }
      const detail = await this.$api.getNewTaxInvoiceDetail(id, this.buildCommonParams(this.currentBill))
      this.detailInfo = detail || {}
      this.detailDialogVisible = true
    },
    async downloadSelectedInvoices() {
      if (!this.selectedOpenedRows.length) {
        this.$message.warning('请选择要下载的发票')
        return
      }
      const ids = this.selectedOpenedRows.map((row) => row.id)
      const result = await this.$api.downloadNewTaxInvoiceOpenedRecords({ ids })
      this.openUrls((result && result.file_urls) || [])
      if (result && result.missing_ids && result.missing_ids.length) {
        this.$message.warning(`部分记录暂无下载地址：${result.missing_ids.join(',')}`)
      }
    },
    openRowDownload(row) {
      const urls = []
        .concat(this.parseUrlList(row.download_urls))
        .concat(this.parseUrlList(row.pdf_oss_urls))
        .concat(this.parseUrlList(row.invoice_file))
      this.openUrls(urls)
    },
    async downloadAllInvoices(row) {
      const result = await this.$api.downloadAllNewTaxInvoiceOpenedRecords(this.buildCommonParams(row))
      if (result && result.zip_url) {
        window.open(result.zip_url, '_blank')
        return
      }
      this.$message.warning('暂无可下载发票')
    },
    openUrls(urls) {
      const list = this.uniqueList(this.parseUrlList(urls))
      if (!list.length) {
        this.$message.warning('暂无可下载发票')
        return
      }
      list.forEach((url) => window.open(url, '_blank'))
    },
    parseUrlList(value) {
      if (!value) return []
      if (Array.isArray(value)) return value.filter(Boolean)
      if (typeof value === 'string') {
        try {
          const json = JSON.parse(value)
          if (Array.isArray(json)) return json.filter(Boolean)
        } catch (e) {
          return value ? [value] : []
        }
        return value ? [value] : []
      }
      return []
    },
    uniqueList(list) {
      return Array.from(new Set(list))
    },
    backToBillList() {
      this.viewMode = 'bill'
      this.currentBill = {}
      this.pendingList = []
      this.openedList = []
      this.selectedPendingRows = []
      this.selectedOpenedRows = []
    },
    sumAmount(list, field) {
      return (list || []).reduce((total, item) => total + Number(item[field] || 0), 0)
    },
    formatMoney(value) {
      const numberValue = Number(value || 0)
      return numberValue.toFixed(2)
    },
    formatInvoiceType(value) {
      const type = String(value || '')
      if (type === '1') return '增值税专票'
      if (type === '2') return '增值税普票'
      return value || '-'
    },
  },
  mounted() {
    this.loadBillRecords()
  },
}
</script>

<style lang="scss" scoped>
.toolbar-row {
  margin-bottom: 16px;
}

.search-input {
  width: 180px;
}

.sub-page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.sub-page-title {
  margin-left: 12px;
  font-size: 16px;
  font-weight: 600;
}

.sub-page-info span {
  margin-left: 18px;
  color: #606266;
}

.table-toolbar {
  margin-bottom: 12px;
  text-align: right;
}

.apply-page-content {
  padding: 20px;
  background: #fff;
  border: 1px solid #ebeef5;
}

.confirm-table {
  margin-top: 16px;
}

.footer-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  margin-top: 16px;
}

.selected-bills {
  margin-top: 12px;
}

.selected-bills-title {
  margin-bottom: 8px;
  font-weight: 600;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  border-top: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
}

.detail-item {
  display: flex;
  min-height: 40px;
  border-right: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}

.detail-label {
  width: 88px;
  padding: 10px;
  background: #fafafa;
  color: #606266;
}

.detail-item span:last-child {
  flex: 1;
  padding: 10px;
}
</style>
